import { EventSpace2ActionTypes } from '../../../../../actions/dashboards/EventSpace2'
import { Metrics } from '../../../../../constants/Dashboards'
import buildAsyncStatReducer from '../../asyncStatReducer'

/**
 * Event Space 2 Interactions (Grouped)
 */
const EventSpace2InteractionsGrouped = buildAsyncStatReducer({
  key: Metrics.EVENTSPACE2_INTERACTIONS_GROUPED,
  types: EventSpace2ActionTypes.DASHBOARD_EVENTSPACE2_INTERACTIONS_GROUPED,
  transform: (state, { payload }) => {
    // @ts-ignore
    return payload.map(({ type: interactionType, count: interactionCount }) => ({
      type: interactionType,
      count: interactionCount,
    }))
  },
})

export default EventSpace2InteractionsGrouped
